module.exports = __webpack_public_path__ + "static/next-8b02c5cdbdc415214b66e2919aee0971.png";